import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/base/Seo";
import { categories } from "@/mocks/categories";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <Seo
        title="页面不存在（404）| 网红大瓜"
        description="你访问的页面可能已被移除或链接有误。返回网红大瓜首页，继续查看最新重磅爆料与热门猛料。"
        canonicalPath="/"
      />
      <section className="relative overflow-hidden bg-foreground-950">
        <div className="relative z-10 mx-auto flex max-w-[1400px] flex-col items-center px-4 py-24 text-center md:px-6 md:py-32">
          <span className="mb-6 font-heading text-6xl font-black tracking-widest text-background-50/20 md:text-9xl">
            404
          </span>
          <span className="mb-4 inline-flex items-center gap-2 rounded-full border border-background-50/20 bg-background-50/10 px-4 py-1.5 text-xs text-background-100 backdrop-blur">
            <i className="ri-emotion-unhappy-line text-accent-400" />
            这个瓜走丢了
          </span>
          <h1 className="mb-4 font-heading text-2xl font-black text-background-50 md:text-4xl">
            没有找到你想要看的页面
          </h1>
          <p className="mb-8 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
            链接可能输错了，也可能是内容正在核对调整。你可以回到首页，或者直接进某个瓜类栏目逛逛。
          </p>
          <p className="mb-8 font-mono text-xs text-background-400">{location.pathname}</p>
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              <i className="ri-home-4-line" />
              返回首页
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:border-accent-500 hover:text-accent-400 cursor-pointer"
            >
              联系编辑部
            </Link>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-4 py-14 md:px-6 md:py-16">
        <h2 className="mb-6 text-center font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          或者，挑个栏目继续吃瓜
        </h2>
        <div className="grid grid-cols-2 gap-4 md:grid-cols-5">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group rounded-lg border border-background-200 bg-background-50 p-5 text-center transition-all hover:-translate-y-1 hover:border-primary-300 cursor-pointer"
            >
              <span className="mx-auto mb-3 flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                <i className="ri-fire-line text-xl" />
              </span>
              <span className="block font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                {category.name}
              </span>
            </Link>
          ))}
        </div>
      </section>
    </SiteLayout>
  );
}